<template>
    <div class="create-favorites-name" ref="createFavorites">
        <h3 class="modal-titles">{{ $TL.createNewFavorite }}</h3>
        <div class="input-slot">
            <v-form
                v-model="valid"
                ref="form"
                class="d-flex align-items-center"
                onSubmit="return false;"
            >
                <v-text-field
                    v-model="favoritesName"
                    class="input-control"
                    :rules="rules"
                    type="text"
                    ref="Input"
                    required
                    @keyup.enter="create"
                ></v-text-field>
                <v-btn class="def gradient-bg submit-btn" @click="create">{{
                    $TL.create
                }}</v-btn>
            </v-form>
        </div>
    </div>
</template>

<script>
import { timeout } from "@/utils/util.js";
import { createFavorites } from "@/api/interface.js";
import { mapMutations, mapState } from "vuex";

export default {
    name: "create-favorites-name",

    data() {
        return {
            valid: false,
            favoritesName: "",
            rules: [
                v => !!v || this.$TL.contentCanNotNull,
                v =>
                    (v && v.length <= 30) ||
                    this.$TL.contentLengthCannotExceed30
            ]
        };
    },
    computed: {
        isOpenDialog() {
            return this.$store.state.vModal.isCreateFavoriteDialogShow;
        }
    },
    watch: {
        isOpenDialog(newVal) {
            newVal && this.focus_input();
        }
    },
    created() {},
    mounted() {
        this.focus_input();
    },
    beforeDestroy() {},
    methods: {
        ...mapMutations("triggerEvtents", ["updateSnackbar"]),
        async create() {
            if (!this.$refs.form.validate()) return;
            this.favoritesName = this.favoritesName.trim();
            if (this.favoritesName !== "") {
                let { data } = await createFavorites({
                    name: this.favoritesName
                });
                this.$P.$emit("createFavoritesName", {
                    name: this.favoritesName,
                    id: data.id
                });
                this.$emit("close");
                this.$P.$emit("updateFavoritesData");
                this.updateSnackbar(this.$TL.favoritesCreatedSuccess);
                this.favoritesName = "";
            }
        },
        async focus_input() {
            await timeout(500);
            this.$refs.Input.focus();
        },

        reset() {
            this.$refs.form.reset();
        }
    }
};
</script>

<style lang="scss">
.createFavoritesName {
    z-index: 10200 !important;
    .v-dialog {
        width: 428px;
    }
}
.create-favorites-name {
    padding: 6px 12px 12px 12px;

    .input-slot {
        margin-top: 18px;
    }

    .input-control {
        width: 288px;
        border: 1px solid #2874e5;
        padding: 4px 8px;
        border-radius: $border-radius;
        transition: all 0.3s ease;
        font-size: 14px;
        height: 36px;

        &:focus {
            outline: none;
            box-shadow: 0px 0px 0px 3px rgba(#2874e5, 0.2);
        }
    }

    .submit-btn {
        margin-left: 20px;
        flex-shrink: 0;
    }
}

.create-favorites-name,
.edit-favorites {
    .input-control {
        width: 288px;
        border: 1px solid #2874e5;
        padding: 2px 8px;
        border-radius: $border-radius;
        transition: all 0.3s ease;
        font-size: 14px;
        height: 36px;
        position: relative;

        &:focus {
            outline: none;
            border-color: #2874e5 !important;
            box-shadow: 0px 0px 0px 3px rgba(#2874e5, 0.2);
        }

        &.error--text {
            box-shadow: 0px 0px 0px 3px rgba(#d34444, 0.2);
            border-color: #ff5252;
        }

        .v-input__slot {
            &::before,
            &::after {
                display: none;
            }
        }

        .v-text-field__details {
            position: absolute;
            left: 0;
            bottom: -20px;
        }
    }
}
</style>
